import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AuthShell from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import api, { errMessage } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data);
    } catch (err) {
      setError(errMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter your email and we'll send you a reset link."
      footer={<>Remembered it? <Link to="/login" className="font-medium text-[#0D9488] hover:underline">Back to log in</Link></>}
    >
      {sent ? (
        <div className="space-y-4" data-testid="forgot-sent">
          <Alert className="border-slate-200 bg-slate-50">
            <AlertTitle>Check your email</AlertTitle>
            <AlertDescription className="text-slate-600">
              If an account exists for that address, a password reset link has been sent to that email.
            </AlertDescription>
          </Alert>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" noValidate>
          {error && <div role="alert" className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div>}
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#0A2540] text-white hover:bg-[#0c2e4e]" data-testid="forgot-submit">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Send reset link
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
